export const ROOT = '/articles?';
export const ARTICLE = '/articles/:slug';
export const ARTICLE_EDIT = '/articles/:slug/edit';
export const SIGNIN = 'signin';
export const SIGNUP = 'signup';
export const PROFILE = 'profile';
export const ARTICLE_CREATE = 'new-article';
export const STAR = '*';
